const pdfGeneratorModuleRoutes = {
	path: '/v2/pdf-generator',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'invoice',
			component: () => import('./pages/invoices/index.vue'),
		},
	],
};

export { pdfGeneratorModuleRoutes };
